import { getGLobalRepoUrl } from "./api-services";
import axios from "axios";

// === Base URL for Diagnostic Feature ===
const baseUrl = getGLobalRepoUrl("/diagnosticfeature");

// === Get all diagnostic categories with features ===
export const getAllDiagnosticFeatures = (tumorSiteId = null) => axios.get(`${baseUrl}/diagnosticfeature`, {params: {
            tumorSiteId: tumorSiteId
        }});

// === Get all diagnostic other features ===
export const getAllDiagnosticOtherFeatures = (caseId) => axios.get(`${baseUrl}/diagnosticotherfeature`, {
    params: { caseid: caseId }
});

// === Get diagnostic features by category ID ===
export const getDiagnosticFeatureOptionsById = (id) => axios.get(`${baseUrl}/diagnosticfeatureoptions/${id}`);

// === Add or update diagnostic category/feature ===
export const addOrUpdateDiagnosticFeatureCategory = (data, isParent = false, isNA = false, isOtherText = false) =>
    axios.post(`${baseUrl}/addCategoriesdata`, data, {
        params: {
            isParent,
            isNA,
            isOtherText
        }
    });


// === Add other feature ===
export const addOtherFeature = (data, isParent = false, isNA = false, isOtherText = true) =>
    axios.post(`${baseUrl}/addCategoriesdata`, data, {
        params: {
            isParent,
            isNA,
            isOtherText
        }
    });

// === Delete a diagnostic category by ID ===

export const deleteDiagnosticFeatureCategory = (id, type) =>
  axios.delete(`${baseUrl}/deleteCategory`, { params: { id, type } });



// === Optionally, add tenant headers if needed in future ===
// Example:
// const tenantData = $session.getTenantData();
// headers: {
//   'X-TenantID': tenantData && tenantData.id ? tenantData.id : null,
// }
